<template>
  <div class="item tr flex-container flex-row flex-verti-center">
    <div class="td width-120">{{ goods.name }}</div>
    <div class="td width-120" :title="goods.specification">
      {{ goods.specification }}
    </div>
    <ul>
      <li
        v-for="(supplier, index) in goods.suppliers"
        :key="index"
        class="supplier flex-container flex-row flex-verti-center"
      >
        <div class="td width-64 collapse">{{ supplier.brandName }}</div>
        <div class="td width-40 collapse">{{ supplier.unit }}</div>
        <div class="td width-90 td-price collapse">
          {{ supplier.taxIncludedMarketPrice }}
        </div>
        <div class="td width-76 td-contact">
          <el-tooltip content="查看名片" placement="right">
            <i
              title="查看名片"
              class="changshangmingpian gjw-iconfont gjw-icon-changshangmingpian transition-200"
              @click="showContactCard(supplier)"
            />
          </el-tooltip>
        </div>
      </li>
    </ul>
    <el-dialog
      title=""
      :modal-append-to-body="false"
      :modal="false"
      :visible="showContact"
      width="280px"
      :close-on-click-modal="false"
      :before-close="() => (showContact = false)">
      <div class="contact">
        <div class="supplier-line supplier-name">
          <span class="label">公司名称</span>
          <span class="value">{{ supplier.name || "--" }}</span>
        </div>
        <div class="supplier-line supplier-contact">
          <span class="label">联系人</span>
          <span class="value">{{ supplier.contactUserName || "--" }}</span>
        </div>
        <div class="supplier-line supplier-mobile">
          <span class="label">联系电话</span>
          <span class="value">{{ supplier.contactMobile || "--" }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'GoodsItem',
  props: {
    goods: {
      type: Object,
      required: true,
    },
    trackName: [String],
  },
  data() {
    return {
      supplier: {},
      showContact: false,
      showMingPianTip: {},
    }
  },
  methods: {
    showContactCard(supplier) {
      this.supplier = supplier
      this.showContact = true
      const {
        name,
        contactUserName,
        contactMobile,
        brandName,
        unit,
        taxIncludedMarketPrice,
      } = supplier
      const goods = this.goods
      this.$tracks({
        event: this.trackName,
        params: {
          g_c_supplier_info: {
            name,
            contactUserName,
            contactMobile,
          },
          g_c_goods_info: {
            name: goods.name,
            specification: goods.specification,
            brandName,
            unit,
            taxIncludedMarketPrice,
            suppliers: goods.suppliers,
          },
        },
      })
    },
  },
  computed: {},
}
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  margin-top: 5vh !important;
  background-color: #14141e;
  opacity: 0.9;
  .el-dialog__close {
    color: #ffffff;
    font-size: 20px;
  }
  .el-dialog__body {
    color: #ffffff;
    padding-top: 10px;
  }
  .el-dialog__headerbtn {
    top: 12px;
  }
}
/deep/.el-dialog__wrapper {
  position: absolute;
}
/deep/.el-tooltip__popper.is-dark {
  max-width: 180px;
}
.item {
  padding: 8px;
}
.tr {
  border-bottom: 1px solid @theme-border-color;
}

.td {
  padding-left: 4px;
  &.td-price {
    font-weight: bold;
    color: @theme-orange;
  }
  .changshangmingpian {
    cursor: pointer;
    color: @theme-grey-3;
    &:hover {
      color: @theme-hover-color;
    }
  }
}

.collapse {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.supplier {
  padding: 8px 0;
  border-bottom: 1px solid @theme-border-color;
  &:first-child {
    padding-top: 0px;
  }
  &:last-child {
    border-bottom: none;
    padding-bottom: 0px;
  }
}
.supplier-line {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 4px;
  .label {
    display: inline-block;
    padding-right: 16px;
    // color: #50505A;
    width: 58px;
    margin-right: 8px;
  }
  .value {
    flex: 1;
  }
  &.supplier-mobile {
    align-items: center;
  }
}
.td-contact {
  position: relative;
}
</style>
